export default {
      id: "icon-download-usage",
      viewBox: "0 0 16 19",
      url: "../icon/" + "icons.svg#icon-download-usage",
      toString: function () {
        return this.url;
      }
    }